// extracted by mini-css-extract-plugin
export default {"errorPage":"errors_errorPage__vVAC3"};